import { ASSIGN_CONTEXT } from "../types";

export default function(key, value) {
  return {
    key,
    value,
    type: ASSIGN_CONTEXT
  };
}
